import { createSelector } from 'reselect';

const makeGetDelayedAccessSettings = () => {
  return createSelector(
    state => state.selected ? state.selected.toc : [],
    toc => {
      return toc.map(section => ({
        id: section.id,
        name: section.name,
        accessDelay: section.accessDelay
      }));
    }
  );
};

export const getDelayedAccessSettings = makeGetDelayedAccessSettings();



// WEBPACK FOOTER //
// ./src/js/selectors/dripContent.selector.js